function Logo() {
    return <img src='/logo.png' alt='logo' />;
}

export default Logo;
